import axios from '@/axios'


const state = {
  error: undefined,
  loading: false,
  blogOneId:undefined,
  edit:[]
};

const actions = {

  async save({commit}, payload) {
    try {
      commit('LOADING', true);
      await axios.post('admin/post',payload);
    } catch (e) {
      throw e;
    } finally {
      commit('LOADING', false);
    }
  },

  async get({commit},id) {
    try {
      commit('LOADING', true);
      let res = await axios.get('admin/post/'+id);
      console.log(res.data,'res data')
      commit('BLOG_ID', res.data);
    } catch (e) {
      commit('ERROR', e);
      throw e;
    } finally {
      commit('LOADING', false);
    }
  },

  async put({commit}, payload) {
    try{
      commit('LOADING', true);
      await axios.put('admin/post/'+payload.id, {id:payload.id,data:payload.data,op:'update'})
      commit('UPDATE_BLOG', payload);
    }catch (e) {
      commit('ERROR', e);
    } finally {
      commit('LOADING', false);
    }
  },

  async submitCountWriting({commit}, payload) {
    try{
      commit('LOADING', true);
      const writing = await axios.post('admin/post/chart/date',payload)
      return writing
    }
    catch (e) {
      this.$ntSetError()
    }
    finally {
      commit('LOADING', false);
    }
  }


}

const mutations = {
  LOADING(state, payload) {
    state.loading = payload;
  },
  BLOG_ID(state,payload){
    state.blogOneId = payload
  },
  UPDATE_BLOG(state, payload) {
    state.edit = state.edit.map(blog => {
      if (blog.id === payload.id) {
        return Object.assign({},blog, payload.data)
      }
      return blog
    })
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
